// Re-export from api shared domain - single source of truth
export type { SupportedLanguage } from "../../../api/src/shared/domain/language";

export enum OrganisationUid {
  JUISCI = "juisci",
  BIOCODEX = "biocodex-rd",
  // SFRO = "sfro",
  // SFR = "sfr",
  // ROYAL_CANIN = "royal-canin",
  // SPILF = "spilf",
  // MGEN = "mgen",
  // OPELLA = "opella-body-pain",
  // ESR = "esr",
  TAKEDA = "takeda-lymphoma-app",
  // UCB = "ucb-rare-diseases",
  // ORPEA = "orpea-eldery-app",
  // SANOFI_AUDIOROOM = "sanoficoughcoldfluaudioroom",
}

export enum SoundEffect {
  LIKE = "like",
  SAVE = "save",
  SHARE = "share",
}

export enum HapticEffect {
  SELECTION = "selection",
  SUCCESS = "success",
  BLENDER = "blender",
  ERROR = "error",
}

export enum PreferredContent {
  SCIENTIFIC_PUBLICATIONS = "Scientific publications",
  MEDICAL_GUIDELINES = "Medical guidelines",
  EDITORIAL_CONTENT = "Editorial content",
  VIDEOS = "Videos",
  PODCASTS = "Podcasts",
}
